import { jumboMediaAPI } from "../../../api/service";
import type { GlobalNotificationT, GlobalSettingsT } from "../models/models";

const ONE_MINUTE = 60;

export const globalSettingsAPI = jumboMediaAPI.injectEndpoints({
  endpoints: (build) => ({
    getGlobalSettings: build.query<GlobalSettingsT, void>({
      query: () => ({
        url: `api/GlobalSettings/GetGlobalSetting`,
        method: "GET",
      }),
    }),
    updateGlobalSettings: build.mutation<void, GlobalSettingsT>({
      query: (body) => ({
        url: "/api/GlobalSettings/UpdateGlobalSettings",
        method: "PUT",
        body,
      }),
    }),
    getIsNewPrices2024Enabled: build.query<boolean, void>({
      query: () => ({
        url: "/api/GlobalSettings/IsNewPracing",
        method: "GET",
      }),
      keepUnusedDataFor: ONE_MINUTE,
    }),
    getGlobalNotification: build.query<GlobalNotificationT, void>({
      query: () => ({
        url: "/api/GlobalSettings/GetGlobalNotification",
        method: "GET",
      }),
    }),
    getNotificationSetting: build.query<
      { NotificationSettingModels: GlobalNotificationT[] },
      void
    >({
      query: () => ({
        url: "/api/GlobalSettings/GetNotificationSetting",
        method: "GET",
      }),
      providesTags: ["NotificationSetting"],
    }),
    updateNotificationSettings: build.mutation<
      void,
      { NotificationSettingModels: GlobalNotificationT[] }
    >({
      query: (body) => ({
        url: "/api/GlobalSettings/UpdateNotificationSettings",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["NotificationSetting"],
    }),
  }),
});

export const {
  useGetGlobalSettingsQuery,
  useLazyGetGlobalSettingsQuery,
  useUpdateGlobalSettingsMutation,
  useGetIsNewPrices2024EnabledQuery,
  useLazyGetIsNewPrices2024EnabledQuery,
  useGetGlobalNotificationQuery,
  useLazyGetGlobalNotificationQuery,
  useGetNotificationSettingQuery,
  useLazyGetNotificationSettingQuery,
  useUpdateNotificationSettingsMutation,
} = globalSettingsAPI;
